import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  userId: number;
};

const [useLeaveSpace, leaveSpace] = createAsyncAction(
  "spaceMembers/leave",
  async ({ spaceId, userId }: Args) => {
    const res = await API.call<{ member: string }>({
      endpoint: `spaces/${spaceId}/members/${userId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.member };
  }
);

export default useLeaveSpace;
export { leaveSpace };
